<template>
  <div class="service-synopsis">
    <marketing-block v-for="panel in panels"
      v-bind="panel"
      :key="`${view}.${panel.name}`"
      :view="view" />
    <div class="service-garden-wrapper">
      <h2>{{$t(`${view}.SERVICE_GARDEN_HEADING`)}}</h2>
      <div class="service-garden">
        <service-garden-item v-for="item in serviceGarden"
          v-bind="item"
          :key="`${view}.${item.name}`"
          :view="view" />
      </div>
    </div>
    <div class="final-cta" :class="{'no-button': !showFooterCTA(view)}">
      <h2>{{$t(`${view}.FINAL_CTA_HEADING`)}}</h2>
      <p>{{$t(`${view}.FINAL_CTA_BODY`)}}</p>
      <router-link v-if="showFooterCTA(view)" :to="{path: '/register', query: { from: legacyService}}">
        <md-button class="md-raised md-primary final-service-cta">
          <div v-html="$t(`${view}.FINAL_CTA_ACTION`)"></div>
        </md-button>
      </router-link>
      <div v-if="embedFooter" class="footer-embed">
        <component :is="embedFooter" :onAttemptedSubmit="openLoginModal"/>
      </div>
    </div>
    <div v-if="view in upgradeDetails">
      <tier-list :view="view"
        v-bind="upgradeDetails[view]"
        :onSubmit="onSubmit" />
    </div>
  </div>
</template>
<style lang="scss">
  .final-service-cta {
    height: 44px;
  }
</style>
<script>
import MarketingBlock from 'components/marketing-block'
import ServiceGarden from 'components/service-garden-item'
import TierList from 'brave-upgrade/components/tier-list'
import {UPGRADE_DETAILS, GLOBAL_SETTINGS, LEGACY_SERVICE_MAPPING} from 'app-constants'
import {HOSTING_CHECKOUT_URL, DOMAINS_CHECKOUT_URL} from 'brave-api/constants'
import login from 'brave-authentication/components/login'
import register from 'brave-authentication/components/register'
import DomainAvailabilityChecker from 'brave-domain/components/domain-availability-checker'
export default {
  components: {
    'marketing-block': MarketingBlock,
    'service-garden-item': ServiceGarden,
    'tier-list': TierList,
    DomainAvailabilityChecker
  },
  data () {
    let embedFooter = null
    if (this.view in GLOBAL_SETTINGS && GLOBAL_SETTINGS[this.view].embedFooter) {
      switch (GLOBAL_SETTINGS[this.view].embedFooter) {
        case 'domain-availability-checker':
          embedFooter = DomainAvailabilityChecker
          break
        default:
          break
      }
    }
    return {
      upgradeDetails: UPGRADE_DETAILS,
      legacyService: LEGACY_SERVICE_MAPPING[this.view],
      embedFooter
    }
  },
  methods: {
    openLoginModal: function () {
      let props = {
        onSuccess: function (data) {

          let redirect = DOMAINS_CHECKOUT_URL.replace('$CURRENT_PUB$', data.response.pub)
          window.location.assign(redirect)
        }
      }
      this.$store.dispatch('pushModal', {component: login, props})
    },
    onSubmit: function (ev) {
      let props = {
        onSuccess: function (data) {

          let redirect = HOSTING_CHECKOUT_URL.replace('$CURRENT_PUB$', data.response.pub)
          let itemPicked = ev.type
          let queryString = `?pickItem=${itemPicked}`
          window.location.assign(`${redirect}${queryString}`)
        },
        type: ev.type  // Pass the plan type to the register modal
      }
      this.$store.dispatch('pushModal', {component: register, props})
    },
    showFooterCTA: function (view) {
      return !(view in GLOBAL_SETTINGS) || !GLOBAL_SETTINGS[view].hideFooterCTA
    }
  },
  props: ['view', 'panels', 'serviceGarden']
}
</script>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/service-synopsis.vue